import { render, staticRenderFns } from "./PublicationForm.vue?vue&type=template&id=1a5f412a"
import script from "./PublicationForm.vue?vue&type=script&lang=js"
export * from "./PublicationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports